import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { ERROR_MESSAGES } from "app/data/common/errorMessages";
import { apiQueryAdapter } from "app/data/apiQueryAdapter";
import { getCurrentUser } from "slices/user/userSlice";
import { useDispatch } from "react-redux";


export const useUpdatePreferenceMutation = (onError?: (error: any) => void) => {
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: async (enabled: boolean) => {
      const response = await apiQueryAdapter.query(
        `/users/preferences/crisp-chat`,
        "PUT",
        { body: { "enabled": enabled } }
      );

      return response.data;
    },
    onSuccess: () => {
      toast.info("Updated successfully");
      dispatch(getCurrentUser(""));
    },
    onError: (e: any) => {
      onError?.(e);
      if (e instanceof Error) {
        toast.error(e.message);
      } else if (e?.response?.data?.message) {
        toast.error(e.response.data.message);
      } else {
        toast.error(ERROR_MESSAGES.COMMON);
      }
    },
  });
};

